export const UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
export const SHA256_HEADER = "X-Amz-Content-Sha256";
export const ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
export const CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
export const AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
export const SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
export const EXPIRES_QUERY_PARAM = "X-Amz-Expires";
export const HOST_HEADER = "host";
export const ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
